import Header from './components/Header';
import Hero from './components/Hero';
import SectionApp from './components/SectionApp';
import SectionComments from './components/SectionComments';
import SectionMedia from './components/SectionMedia';
import SectionFeatures from './components/SectionFeatures';
import SectionTopics from './components/SectionTopics';
import SectionIndex from './components/SectionIndex';
import SectionCarousel from './components/SectionCarousel';
import SectionFaq from './components/SectionFaq';
import SectionAbout from './components/SectionAbout';
import SectionUpdates from './components/SectionUpdates';
import SectionCards from './components/SectionCards';
import SectionRanking from './components/SectionRanking';
import SectionContact from './components/SectionContact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <SectionApp />
        <SectionComments />
        <SectionMedia />
        <SectionFeatures />
        <SectionTopics />
        <SectionIndex />
        <SectionCarousel />
        <SectionFaq />
        <SectionAbout />
        <SectionUpdates />
        <SectionCards />
        <SectionRanking />
        <SectionContact />
      </main>
      <Footer />
    </div>
  );
}